import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Button,
    Col,
    Row,
    Typography,
    notification,
    Form,
    Input, Select, Skeleton,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import arrowLeft from '../../../src/img/arrow-left.png';
import MultiLangSelector from "../MultiLangSelector";

interface Props {
    location: any;
    selectedLanguage:any
}
export default function LevelForm(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [item, setItem] = useState(null as any);
    const [uploading, setUploading] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const [lang, setLang] = useState('' as any);
    
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchLevelById(RouteParams['id']);
            setItem({
                ...data,
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
        setLang(localStorage.getItem('language'));
    }, []);

    if (fetching) {
        return <Skeleton active={true}/>;
    }
    return (
        <div className={'list-page-wrapper'}>
            <div className="container-fluid">
                <div className={'d-flex justify-space-between mb-3'}>
                    <div className='col-md-12 p-0 d-flex align-items-center'>
                        <div className={lang == 'ar' ? '' : 'mr-4'}>
                        <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                        </div>
                        <div className={lang == 'ar' ? 'ml-2 text-sm-right' : 'text-sm-right'}><h3 className='mb-0'>{RouteParams['mode'] === 'create' ? t('level.create') : ''}</h3></div>
                    </div>
                </div>
                <div className={lang === 'ar' ? 'row text-right' : 'row'}>
                    <div className='col-md-12'>
                        <div className='bg-white p-3 br-5px'>
                            <div className='pt-3 pb-3 pl-4 pr-6rem'>
                                <Form
                                    size="large"
                                    form={form}
                                    initialValues={item}
                                    fields={[]}
                                    onFinish={(value) => {
                                        const reqObj: any = value;
                                        console.log('reqObj',reqObj);
                                        // return 
                                        setSaving(true);
                                        if (item && item.id) {
                                            API_SERVICE.updateLevel(item.id, reqObj).then((d) => {
                                                history.goBack();
                                            }).catch((e) => {
                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                setSaving(false);
                                            });
                                        } else {
                                            API_SERVICE.createLevel(reqObj).then((d) => {
                                                history.goBack();
                                            }).catch((e) => {
                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                setSaving(false);
                                            });
                                        }
                                    }}
                                    layout="vertical"
                                    requiredMark={true}
                                >
                                    <Row>
                                        <Col lg={10} md={10} sm={24} xs={24} className="mt-4">
                                            <h5 className={lang == 'ar' ? 'mr-4' : 'mt-4'}>{t('genDict.levelInformation')}</h5>
                                            <p className={lang == 'ar' ? 'mr-4' : 'text-secondary'}>{t('genDict.levelInformationParagraph')}</p>
                                        </Col>
                                        
                                        <Col lg={14} md={14} sm={24} xs={24} className="mt-4">
                                        
                                        {/* <div className='d-flex align-items-center'>
                                            <div>
                                                <select name={'change_langs'} className='form-control change_langs' onChange={(e) => {
                                                    selectedLangs(e.target.value);
                                                } }
                                                    style={{ marginRight: '10px' }}>
                                                    {Langs.map(({ val }) => <option value={val}>{val}</option>)}
                                                </select>
                                            </div>
                                            <div style={{ background: "#333", padding: "1px" }}>
                                                {selectedLang === 'en' ? <img src={EN} style={{ width: '55px' }} />
                                                    : selectedLang === 'de' ? <img src={DE} style={{ width: '55px' }} />
                                                        : selectedLang === 'it' ? <img src={IT} style={{ width: '55px' }} />
                                                            : selectedLang === 'fr' ? <img src={FR} style={{ width: '55px' }} />
                                                                : ''}
                                            </div>
                                        </div>
                                        {Langs.map(( {val})  =>
                                            <Form.Item
                                                label={t('level.name.label')}
                                                name={['name', val]}
                                                initialValue={val}
                                                rules={[
                                                    { required: true, message: t('level.name.required') },
                                                ]}
                                                className={'form-input-'+val} 
                                                style={{ display: val===selectedLang ? "block" : "none" }}
                                            >
                                                <Input className='form-control' disabled={RouteParams['mode'] === 'view'}/>
                                            </Form.Item>
                                        )} */}
                                        {/* <Form.Item
                                            label={t('level.nameDe.label')}
                                            name={['name', 'de']}
                                            rules={[
                                                { required: true, message: t('level.nameDe.required') },
                                            ]}
                                        >
                                            <Input className='form-control' disabled={RouteParams['mode'] === 'view'}/>
                                        </Form.Item> */}
                                        <Form.Item
                                            label={t('name.label')}
                                            name={['name', selectedLang]}
                                            rules={[
                                                { required: true, message: t('name.required') },
                                            ]}>
                                            <Input className='form-control' disabled={RouteParams['mode'] === 'view'}/>
                                        </Form.Item>
                                            
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row>
                                        <Col lg={24} md={24} sm={24} xs={24}>
                                            {
                                                RouteParams['mode'] !== 'view' && <Form.Item>
                                                    <Button
                                                        htmlType="submit"
                                                        loading={saving || uploading}
                                                        size={'large'}
                                                        className="submit btn-blue float-right"
                                                    >
                                                        {t('genDict.save')}
                                                    </Button>
                                                    <Button                                 
                                                        htmlType="reset"
                                                        size={'large'}
                                                        className="reset mr-3 btn-default float-right"
                                                    >
                                                        {t('genDict.cancel')}
                                                    </Button>
                                                </Form.Item>
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
